import * as types from 'store/modules/hres72u/mutation-types'
import hres72u from 'api/hres72u'
import swal from 'sweetalert'
import hres72uLabels from 'assets/labels/hres72u'
import { hres72uColumns } from 'assets/columns/hres72u'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres72uLabels,
    columns: hres72uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {}
    },
    detailTab2Popup: {},
    approve: {},
    indexSelected: [],
    detailSubmit: {
      tab1: {}
    }
  },
  getters: {
    [types.GET_HRES72U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES72U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES72U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES72U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES72U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES72U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES72U_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES72U_DETAIL_TAB2_POPUP] (state) {
      return state.detailTab2Popup
    },
    [types.GET_HRES72U_DETAIL_SUBMIT] (state) {
      return state.detailSubmit
    }
  },
  mutations: {
    [types.SET_HRES72U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES72U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES72U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
      }
    },
    [types.SET_HRES72U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES72U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES72U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES72U_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES72U_DETAIL_TAB2_POPUP] (state, detailTab2Popup) {
      state.detailTab2Popup = detailTab2Popup
    },
    [types.SET_HRES72U_DETAIL_SUBMIT] (state, data) {
      state.detailSubmit = data
    }
  },
  actions: {
    [types.TOGGLE_HRES72U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES72U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES72U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES72U_COLUMNS_LABELS] ({ commit }) {
      hres72u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES72U_COLUMNS, data.labels)
          commit(types.SET_HRES72U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES72U_INDEX] ({ commit }, searchParams) {
      hres72u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES72U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES72U_DETAIL] ({ commit }, detailParams) {
      hres72u.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES72U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES72U_DETAIL_TAB2_POPUP] ({ commit }, popupParams) {
      hres72u.getDetailTab2Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES72U_DETAIL_TAB2_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES72U_DETAIL_SUBMIT] ({ commit }, detailParams) {
      hres72u.getDetailSubmit(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES72U_DETAIL_SUBMIT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES72U_SEND_APPROVE] ({ commit, dispatch }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          let referenceButton = params.referenceButton
          params.approveParams.flgwarning = 'N'
          hres72u.postSendApprove(params.approveParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            if (data.flg === 'warning') {
              swal({
                title: constLabels('confirmTitle'),
                text: data.response,
                html: true,
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: constLabels('ok'),
                cancelButtonText: constLabels('cancel')
              },
              function (isConfirm) {
                if (isConfirm) {
                  swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
                  params.approveParams.flgwarning = 'Y'
                  hres72u.postSendApprove(params.approveParams)
                  .then((response) => {
                    const data = JSON.parse(response.request.response)
                    dispatch(types.RECEIVED_HRES72U_INDEX, {})
                    dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
                    swal({title: '', text: data.response, html: true, type: 'success'}, function () {
                      referenceButton.click()
                    })
                  })
                  .catch((error) => {
                    const data = error.response.data
                    swal({
                      title: '', text: data.response, html: true, type: 'error'
                    }, function () {
                      window.onkeydown = null; window.onfocus = null; swal('')
                    })
                  })
                }
              })
            } else {
              dispatch(types.RECEIVED_HRES72U_INDEX, {})
              dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
              swal({title: '', text: data.response, html: true, type: 'success'}, function () {
                referenceButton.click()
              })
            }
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres72u/index.js